// import React from "react";

// const MembersSection = ({ members }) => {
//     return (
//         <div className="w-full">
//             <div className="flex flex-wrap justify-center gap-8">
//                 {members.map((member) => (
//                     <div
//                         key={member.name}
//                         className="
//                             w-[35%]            /* mobile: 2 per row */
//                             sm:w-[48%]         /* small screens */
//                             md:w-[30%]         /* tablet: 3 per row */
//                             lg:w-[20%]         /* desktop: 5 per row */
//                             flex flex-col items-center
//                         "
//                     >
//                         {/* Image */}
//                         <div className="w-28 h-28 sm:w-32 sm:h-32 md:w-38 md:h-38 lg:w-[115px] lg:h-[115px] border border-gray-300 shadow-md rounded-lg overflow-hidden bg-white">
//                             <img
//                                 src={member.img}
//                                 alt={member.name}
//                                 className="w-full h-full object-cover object-top"
//                             />
//                         </div>

//                         {/* Name */}
//                         <p className="font-futura mt-[6px] font-medium text-sm sm:text-base lg:text-[16px] text-center">
//                             {member.name}
//                         </p>

//                         {/* Role */}
//                         <p className="font-futura text-xs sm:text-sm text-gray-500 mt-[3px] text-center px-1 lg:text-[13px]">
//                             {member.role.split(",").map((part) => (
//                                 <span
//                                     key={`${member.name}-${part.trim()}`}
//                                     className="block"
//                                 >
//                                     {part.trim()}
//                                 </span>
//                             ))}
//                         </p>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default MembersSection;


import React from "react";

const MembersSection = ({ members }) => {
    const itemsPerRowLg = 5;
    const remainder = members.length % itemsPerRowLg;
    const lastRowStartIndex =
        remainder === 0 ? members.length : members.length - remainder;

    return (
        <div className="w-full">
            <div
                className="
                    grid
                    grid-cols-2
                    sm:grid-cols-2
                    md:grid-cols-3
                    lg:grid-cols-5
                    gap-6
                    lg:gap-10
                    xl:gap-12
                "
            >
                {/* Normal items */}
                {members.slice(0, lastRowStartIndex).map((member) => (
                    <MemberCard key={member.name} member={member} />
                ))}

                {/* Last row */}
                {remainder > 0 && (
                    <>
                        {/* Mobile & Tablet */}
                        {members.slice(lastRowStartIndex).map((member) => (
                            <div key={member.name} className="lg:hidden">
                                <MemberCard member={member} />
                            </div>
                        ))}

                        {/* Large screen centered */}
                        <div className="hidden lg:flex lg:col-span-5 justify-center gap-10">
                            {members.slice(lastRowStartIndex).map((member) => (
                                <MemberCard key={member.name} member={member} />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const MemberCard = ({ member }) => (
    <div className="flex flex-col items-center">
        <div className="
            w-24 h-24
            sm:w-28 sm:h-28
            md:w-32 md:h-32
            lg:w-[100px] lg:h-[100px]
            xl:w-[115px] xl:h-[115px]
            border border-gray-300 shadow-md rounded-lg overflow-hidden bg-white
        ">
            <img
                src={member.img}
                alt={member.name}
                className="w-full h-full object-cover object-top"
            />
        </div>

        <p className="font-futura mt-2 font-medium text-xs sm:text-sm md:text-base lg:text-[15px] xl:text-[16px] text-center xl:whitespace-nowrap lg:whitespace-normal">
            {member.name}
        </p>

        <p className="font-futura text-[10px] sm:text-xs md:text-xs lg:text-xs xl:text-xs text-gray-500 mt-1 text-center px-1">
            {member.role.split(",").map((part) => (
                <span key={part} className="block">
                    {part.trim()}
                </span>
            ))}
        </p>
    </div>
);

export default MembersSection;

